import { InputField } from 'components/molecules'

const ProductSkuFilterField = () => (
  <>
    <InputField
      name='sku'
      label='SKU'
      placeholder='Product SKU'
      type='text'
    />
  </>
)

export default ProductSkuFilterField
